/* VILUNA — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll (un solo observer) ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    document.documentElement.classList.add('mt-reveal-listo');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px 6% 0px', threshold: 0.01 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  var parallaxListo = false;
  function initParallax() {
    var imgs = document.querySelectorAll('[data-mt-parallax]');
    if (parallaxListo || !imgs.length || reduceMotion) return;
    parallaxListo = true;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var box = img.parentElement.getBoundingClientRect();
        var intensidad = parseFloat(img.getAttribute('data-mt-parallax')) || 0;
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        var progreso = (box.top + box.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.setProperty('--mt-parallax', (-progreso * intensidad).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Rotación de imágenes del hero ---------- */
  function initRotacion(root) {
    (root || document).querySelectorAll('[data-mt-rotacion]').forEach(function (marco) {
      if (marco.dataset.mtListo) return;
      marco.dataset.mtListo = '1';
      var slides = marco.querySelectorAll('.mt-hero__slide');
      if (slides.length < 2 || reduceMotion) return;
      var ms = (parseFloat(marco.getAttribute('data-mt-rotacion')) || 5) * 1000;
      var actual = 0;
      var pausa = false;
      function mostrar(n) {
        slides[actual].classList.remove('is-activa');
        actual = (n + slides.length) % slides.length;
        slides[actual].classList.add('is-activa');
      }
      marco.mtMostrarSlide = function (el) {
        slides.forEach(function (s, i) { if (s === el) mostrar(i); });
      };
      marco.mtPausar = function (v) { pausa = v; };
      marco.addEventListener('mouseenter', function () { pausa = true; });
      marco.addEventListener('mouseleave', function () { pausa = false; });
      setInterval(function () {
        if (pausa || document.hidden) return;
        var sig = slides[(actual + 1) % slides.length];
        if (!sig.complete || !sig.naturalWidth) return; /* no mostrar una foto que aún no ha cargado */
        mostrar(actual + 1);
      }, ms);
    });
  }
  /* Editor de Shopify: al seleccionar un bloque "Imagen", mostrar esa foto y parar la rotación */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var marco = el && el.closest ? el.closest('[data-mt-rotacion]') : null;
    if (marco && marco.mtMostrarSlide) { marco.mtMostrarSlide(el); marco.mtPausar(true); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var marco = e.target && e.target.closest ? e.target.closest('[data-mt-rotacion]') : null;
    if (marco && marco.mtPausar) marco.mtPausar(false);
  });

  /* ---------- Galería de producto (fotos y vídeos) ---------- */
  function initGaleria(root) {
    (root || document).querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      if (galeria.dataset.mtListo) return;
      galeria.dataset.mtListo = '1';
      var slides = galeria.querySelectorAll('.mt-galeria__principal [data-media-id]');
      var minis = galeria.querySelectorAll('.mt-galeria__mini');
      if (!slides.length) return;
      var actual = -1;
      var aLaVista = true;
      slides.forEach(function (s, i) { if (s.classList.contains('is-activa')) actual = i; });
      if (actual < 0) { actual = 0; slides[0].classList.add('is-activa'); }

      /* Vídeos: solo se reproduce el que se está viendo (en bucle, sin sonido); con "reducir movimiento", con controles */
      function videos() {
        slides.forEach(function (s, j) {
          var v = s.querySelector('video');
          if (!v) return;
          if (j === actual && aLaVista) {
            if (reduceMotion) { v.controls = true; return; }
            v.preload = 'auto';
            var p = v.play();
            if (p && p.catch) p.catch(function () { v.controls = true; });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }

      function mostrar(i) {
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-activa', j === actual); });
        minis.forEach(function (m, j) { m.setAttribute('aria-current', j === actual ? 'true' : 'false'); });
        var mini = minis[actual];
        if (mini && mini.scrollIntoView && window.innerWidth > 749) {
          mini.parentElement.scrollTo({ top: mini.offsetTop - 20, behavior: 'smooth' });
        }
        videos();
      }
      galeria.mtMostrarMedia = function (mediaId) {
        slides.forEach(function (s, j) { if (s.dataset.mediaId === String(mediaId)) mostrar(j); });
      };
      if (galeria.querySelector('video')) {
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            aLaVista = entries[0].isIntersecting;
            videos();
          }).observe(galeria);
        }
        /* Al volver a la pestaña, el navegador puede haber pausado el vídeo para ahorrar batería */
        document.addEventListener('visibilitychange', function () { if (!document.hidden) videos(); });
      }
      minis.forEach(function (m, j) { m.addEventListener('click', function () { mostrar(j); }); });
      var prev = galeria.querySelector('[data-mt-prev]');
      var next = galeria.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
      if (next) next.addEventListener('click', function () { mostrar(actual + 1); });

      /* Deslizar con el dedo en móvil */
      var principal = galeria.querySelector('.mt-galeria__principal');
      var x0 = null;
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) mostrar(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* ---------- Variantes, cantidad y barra fija ---------- */
  function formatoDinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    var partes = valor.split('.');
    var conMiles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var coma = conMiles + ',' + partes[1];
    var punto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
    formato = formato || '{{amount_with_comma_separator}} €';
    return formato
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, conMiles)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0])
      .replace(/\{\{\s*amount\s*\}\}/, punto);
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';
      var datos = sec.querySelector('[data-mt-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var formato = sec.dataset.moneyFormat;
      var textos = {
        anadir: sec.dataset.txtAnadir || 'Añadir al carrito',
        agotado: sec.dataset.txtAgotado || 'Agotado',
        noDisponible: sec.dataset.txtNoDisponible || 'No disponible'
      };
      var inputId = sec.querySelector('input[name="id"]');
      var boton = sec.querySelector('[data-mt-boton]');
      var botonTexto = boton ? boton.querySelector('span') : null;
      var precio = sec.querySelector('[data-mt-precio]');
      var antes = sec.querySelector('[data-mt-antes]');
      var ahorro = sec.querySelector('[data-mt-ahorro]');
      var barraPrecio = sec.querySelector('[data-mt-barra-precio]');
      var galeria = sec.querySelector('[data-mt-galeria]');

      function opcionesSeleccionadas() {
        var sel = [];
        sec.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
          var marcado = fs.querySelector('input:checked');
          sel.push(marcado ? marcado.value : null);
          var etiqueta = fs.querySelector('[data-mt-opcion-valor]');
          if (etiqueta && marcado) etiqueta.textContent = marcado.value;
        });
        return sel;
      }

      function actualizar() {
        var sel = opcionesSeleccionadas();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) {
          if (boton) { boton.setAttribute('disabled', 'disabled'); if (botonTexto) botonTexto.textContent = textos.noDisponible; }
          return;
        }
        sec.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = v.id; });
        if (precio) precio.textContent = formatoDinero(v.price, formato);
        if (barraPrecio) barraPrecio.textContent = formatoDinero(v.price, formato);
        if (antes) {
          var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
          antes.hidden = !hayAntes;
          if (hayAntes) antes.textContent = formatoDinero(v.compare_at_price, formato);
          if (ahorro) {
            ahorro.hidden = !hayAntes;
            if (hayAntes) ahorro.textContent = ahorro.dataset.plantilla.replace('%', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
          }
        }
        if (boton) {
          if (v.available) {
            boton.removeAttribute('disabled');
            if (botonTexto) botonTexto.textContent = textos.anadir;
          } else {
            boton.setAttribute('disabled', 'disabled');
            if (botonTexto) botonTexto.textContent = textos.agotado;
          }
        }
        if (v.featured_media && galeria && galeria.mtMostrarMedia) galeria.mtMostrarMedia(v.featured_media.id);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      sec.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });

      /* Cantidad */
      var cantidad = sec.querySelector('[data-mt-cantidad]');
      var cantidadForm = sec.querySelector('input[name="quantity"]');
      if (cantidad && cantidadForm) {
        var campo = cantidad.querySelector('input');
        cantidad.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(campo.value, 10) || 1;
            n = Math.max(1, n + parseInt(b.dataset.paso, 10));
            campo.value = n; cantidadForm.value = n;
          });
        });
        campo.addEventListener('change', function () {
          var n = Math.max(1, parseInt(campo.value, 10) || 1);
          campo.value = n; cantidadForm.value = n;
        });
      }

      /* Barra fija en móvil: aparece cuando el botón principal ha quedado por encima de la pantalla
         (se comprueba en cada scroll, así también funciona con saltos rápidos o al recargar a media página) */
      var barra = sec.querySelector('[data-mt-barra]');
      if (barra && boton) {
        var barraPendiente = false;
        var actualizarBarra = function () {
          barraPendiente = false;
          barra.classList.toggle('is-visible', boton.getBoundingClientRect().bottom < 0);
        };
        window.addEventListener('scroll', function () {
          if (!barraPendiente) { barraPendiente = true; window.requestAnimationFrame(actualizarBarra); }
        }, { passive: true });
        actualizarBarra();
        var barraBoton = barra.querySelector('button');
        if (barraBoton) barraBoton.addEventListener('click', function () {
          if (boton.hasAttribute('disabled')) { boton.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          boton.click();
        });
      }
    });
  }

  /* ---------- "Combínalo": añadir al carrito sin salir de la ficha (abre el carrito lateral) ---------- */
  function initCombina(root) {
    (root || document).querySelectorAll('[data-mt-combina-item]').forEach(function (item) {
      if (item.dataset.mtListo) return;
      item.dataset.mtListo = '1';
      var variante = item.querySelector('[data-mt-combina-variante]');
      var precio = item.querySelector('[data-mt-combina-precio]');
      var boton = item.querySelector('[data-mt-combina-anadir]');
      if (!variante || !boton) return;
      if (variante.tagName === 'SELECT') {
        variante.addEventListener('change', function () {
          var op = variante.options[variante.selectedIndex];
          if (op && op.dataset.precio && precio) precio.textContent = op.dataset.precio;
        });
      }
      boton.addEventListener('click', function () {
        var carrito = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var datos = { id: variante.value, quantity: 1 };
        if (carrito && carrito.getSectionsToRender) {
          datos.sections = carrito.getSectionsToRender().map(function (s) { return s.id; });
          datos.sections_url = window.location.pathname;
          if (carrito.setActiveElement) carrito.setActiveElement(boton);
        }
        var rutaAnadir = (window.routes && window.routes.cart_add_url) || '/cart/add';
        boton.disabled = true;
        fetch(rutaAnadir + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(datos)
        })
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            if (resp.status) { boton.textContent = 'No disponible'; return; }
            boton.textContent = 'Añadido ✓';
            setTimeout(function () { boton.textContent = 'Añadir'; boton.disabled = false; }, 2500);
            if (carrito && carrito.renderContents) {
              /* Igual que el botón principal (product-form.js): si el carrito estaba vacío, quitar esa marca para que se vean los artículos */
              carrito.classList.remove('is-empty');
              carrito.renderContents(resp);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-combina', productVariantId: variante.value, cartData: resp });
              }
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { boton.textContent = 'Inténtalo de nuevo'; boton.disabled = false; });
      });
    });
  }

  /* ---------- Fecha estimada de entrega: hoy + N días laborables (sin fines de semana ni festivos nacionales de fecha fija) ---------- */
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var FESTIVOS = ['1-1', '1-6', '5-1', '8-15', '10-12', '11-1', '12-6', '12-8', '12-25'];
  function sumarLaborables(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    var tope = 120;
    while (n > 0 && tope-- > 0) {
      d.setDate(d.getDate() + 1);
      var dia = d.getDay();
      if (dia !== 0 && dia !== 6 && FESTIVOS.indexOf((d.getMonth() + 1) + '-' + d.getDate()) === -1) n--;
    }
    return d;
  }
  function initEntrega(root) {
    (root || document).querySelectorAll('[data-mt-entrega]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      var plantilla = el.dataset.plantilla || '';
      if (!(min > 0) || !(max >= min) || plantilla.indexOf('[fechas]') === -1) return;
      var a = sumarLaborables(min);
      var b = sumarLaborables(max);
      /* "del 23 al 30 de octubre" o, si cambia el mes, "del 28 de octubre al 4 de noviembre" */
      var desde = a.getMonth() === b.getMonth() ? String(a.getDate()) : a.getDate() + ' de ' + MESES[a.getMonth()];
      var fechas = 'del ' + desde + ' al ' + b.getDate() + ' de ' + MESES[b.getMonth()];
      var partes = plantilla.split(' · ');
      el.textContent = '';
      partes.forEach(function (parte, i) {
        var nodo = document.createElement(i === 0 && partes.length > 1 ? 'strong' : 'span');
        var trozos = parte.split('[fechas]');
        nodo.appendChild(document.createTextNode(trozos[0]));
        if (trozos.length > 1) {
          /* las fechas van en un bloque propio: si no caben en la línea, bajan enteras a la siguiente */
          var bloque = document.createElement('span');
          bloque.className = 'mt-envio__fechas';
          bloque.textContent = fechas;
          nodo.appendChild(bloque);
          nodo.appendChild(document.createTextNode(trozos.slice(1).join(fechas)));
        }
        el.appendChild(nodo);
      });
    });
  }

  function initTodo(root) {
    initReveal(root);
    initRotacion(root);
    initGaleria(root);
    initProducto(root);
    initCombina(root);
    initEntrega(root);
  }

  function arrancar() {
    initTodo(document);
    initParallax();
  }
  /* El script se carga con "defer": el HTML ya está listo, así que arrancamos sin esperar al resto de scripts */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* Editor de Shopify: reinicializar al añadir o editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
